/* global Cookies */

;$(function () {
  'use strict'

  const appPromoPanel = document.querySelector('[data-app-promo-panel]')
  const close = document.querySelector('[data-app-promo-panel-close]')
  const storeLinks = document.querySelectorAll('[data-app-promo-panel-link]')
  const mobileMenu = document.querySelector('[data-mobile-menu]')
  const mobileMenuBackdrop = document.querySelector('[data-mobile-menu-backdrop]')

  const getMobileOperatingSystem = function () {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS'
    }

    if (/android/i.test(userAgent)) {
      return 'Android'
    }
  }

  const showPanel = function () {
    appPromoPanel.classList.add('app-promo-panel_show')
  }

  const deletePanel = function () {
    appPromoPanel.parentNode.removeChild(appPromoPanel)
    Cookies.set(
      'isAppPanelVisible',
      'false',
      {
        domain: window.location.hostname.replace(/^.*(\.\w+\.\w+)$/gi, '$1'),
        expires: 7
      }
    )
    mobileMenu.style.top = '3rem'
    mobileMenuBackdrop.style.top = 0
  }

  if (appPromoPanel) {
    for (var i = 0; i < storeLinks.length; i++) {
      if (getMobileOperatingSystem() === 'iOS') {
        storeLinks[i].href = 'https://itunes.apple.com/ru/app/%D0%BD%D0%B5%D0%B2%D0%B5%D1%81%D1%82%D0%B0-info/id1435784111'
        $(storeLinks[i]).data('tracking-event-label', 'iOS in popup')
      }
      else if (getMobileOperatingSystem() === 'Android') {
        storeLinks[i].href = 'https://play.google.com/store/apps/details?id=com.ibride.nevesta'
        $(storeLinks[i]).data('tracking-event-label', 'Android in popup')
      }
    }

    if (Cookies.get('isAppPanelVisible') !== 'false') showPanel()

    close.addEventListener('click', deletePanel)

    if (document.body.clientWidth <= 767 && appPromoPanel.classList.contains('app-promo-panel_show')) {
      if (mobileMenu) {
        mobileMenu.style.top = '8rem'
      }
      if (mobileMenuBackdrop) {
        mobileMenuBackdrop.style.top = '5rem'
      }
    }
  }
})
